// src/components/LangSetter.tsx
"use client";

import { memo, useEffect } from "react";

import { useDirection, useLanguage } from "@/context/TranslationsContext";

function LangSetterInner() {
  const language = useLanguage();
  const direction = useDirection();

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = direction;
  }, [language, direction]);

  return null;
}

export default memo(LangSetterInner);
